import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  BarsOutlined
} from "@ant-design/icons";
import { Button, Menu } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Col, FormLabel, Row } from "react-bootstrap";
import MediaQuery from "react-responsive";
import { Image } from "react-bootstrap";
import { AppContext } from "../../domain/App/AppContext";

const { SubMenu } = Menu;

let subMenuIndex = 1;

let menuIds = new Set();

const createMenu = menuItems => {
  return menuItems.map(menuItem => {
    const icon = menuItem.icon !== undefined ? menuItem.icon : null;
    if (menuItem.content !== undefined) {
      const keyValue = "sub_" + subMenuIndex++;
      menuIds.add(keyValue);
      return (
        <SubMenu
          key={keyValue}
          title={
            <div id={keyValue} className="iconTextAlign">
              {icon}
              <span id={keyValue}>{menuItem.label}</span>
            </div>
          }
          popupClassName="menu-popup"
        >
          {createMenu(menuItem.content)}
        </SubMenu>
      );
    } else {
      menuIds.add(menuItem.key);
      const title = menuItem.label;
      return (
        <Menu.Item key={menuItem.key} title={title} extra={menuItem.extra}>
          <div id={menuItem.key} className="iconTextAlign">
            {icon}
            <span id={menuItem.key}>{title}</span>
          </div>
        </Menu.Item>
      );
    }
  });
};

const getMenu = (menu, onMenuItemClick, location, collapsed = true) => {
  return (
    <Menu
      defaultSelectedKeys={[location.pathname]}
      mode="inline"
      theme="dark"
      inlineCollapsed={collapsed}
      onClick={item => {
        onMenuItemClick({
          key: item.key,
          label: item.item.props.title,
          extra: item.item.props.extra
        });
      }}
    >
      {menu}
    </Menu>
  );
};

const isInPath = event => {
  if (event.target.nodeName === "path" || event.target.nodeName === "svg") {
    return event.path.map(path => path.id).some(id => menuIds.has(id));
  }
  return false;
};

function useOutsideAlerter(ref, setShowMenu) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (
        ref.current &&
        setShowMenu &&
        !ref.current.contains(event.target) &&
        !menuIds.has(event.target.id) &&
        !isInPath(event)
      ) {
        setShowMenu(false);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, setShowMenu]);
}

const SideMenu = ({
  collapsed,
  menuItems,
  onMenuItemClick,
  location,
  onSideMenuToggle
}) => {
  subMenuIndex = 1;
  const menu = createMenu(menuItems);

  const [showMenu, setShowMenu] = useState(false);
  const miniMenuRef = useRef(null);
  useOutsideAlerter(miniMenuRef, setShowMenu);

  const { logo } = useContext(AppContext);

  return (
    <>
      <MediaQuery minWidth={1025}>
        <div
          className={collapsed ? "menucontainer-collapsed" : "menucontainer"}
        >
          <Row className="sidemenu_container">
            <Col sm={collapsed ? "5" : "9"}>
              <FormLabel className={"navbar-label"}>
                <Image className="logoImage" src={logo?.logoSrc} />
                <div className="navbar-appName">
                  {!collapsed && logo?.logoName}
                </div>
              </FormLabel>
            </Col>
            <Col sm={collapsed ? "7" : "3"}>
              <Button
                type="link"
                onClick={onSideMenuToggle}
                size="large"
                className="sidemenu-toggle_btn"
              >
                {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              </Button>
            </Col>
          </Row>
          {getMenu(menu, onMenuItemClick, location, collapsed)}
        </div>
      </MediaQuery>
      <MediaQuery minWidth={768} maxWidth={1024}>
        <div className={"menucontainer-collapsed"}>
          {getMenu(menu, onMenuItemClick, location)}
        </div>
      </MediaQuery>
      <MediaQuery maxWidth={768}>
        <div
          className="menucontainer-hide"
          style={{ zIndex: showMenu ? 1000 : 100 }}
          ref={miniMenuRef}
        >
          <Button
            type="link"
            onClick={e => setShowMenu(!showMenu)}
            size="large"
            className="sidemenu-toggle_btnMobile"
          >
            {showMenu ? <BarsOutlined rotate={90} /> : <BarsOutlined />}
          </Button>

          {showMenu
            ? getMenu(
                menu,
                props => {
                  setShowMenu(false);
                  onMenuItemClick(props);
                },
                location
              )
            : null}
        </div>
      </MediaQuery>
    </>
  );
};

export default SideMenu;
